import { z } from 'zod';
// --- Recipe (saved sequence of editor steps) ---
export const recipeStepSchema = z.object({
    action: z.string().min(1),
    params: z.record(z.unknown()).default({}),
});
export const createRecipeSchema = z.object({
    name: z.string().min(1).max(200),
    description: z.string().max(1000).default(''),
    steps: z.array(recipeStepSchema).default([]),
    isBuiltIn: z.boolean().default(false),
});
export const updateRecipeSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    description: z.string().max(1000).optional(),
    steps: z.array(recipeStepSchema).optional(),
    isBuiltIn: z.boolean().optional(),
});
// --- Macro (named keyboard-shortcut binding for a series of actions) ---
export const macroActionSchema = z.object({
    type: z.string().min(1),
    params: z.record(z.unknown()).default({}),
});
export const createMacroSchema = z.object({
    name: z.string().min(1).max(200),
    description: z.string().max(1000).default(''),
    actions: z.array(macroActionSchema).default([]),
});
export const updateMacroSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    description: z.string().max(1000).optional(),
    actions: z.array(macroActionSchema).optional(),
});
// --- Project template ---
export const createTemplateSchema = z.object({
    name: z.string().min(1).max(200),
    type: z.string().max(20).default('full'),
    config: z.record(z.unknown()).default({}),
});
//# sourceMappingURL=workflow.schemas.js.map